import { ActivatedRouteSnapshot, Router } from '@angular/router';

/**
 * Builds the matched route pattern from the router snapshot so per-entity pages group together as one
 * page in analytics (e.g. `/enrollments/:id/lessons/:lessonId` rather than a URL with real IDs).
 * Walks the primary-outlet chain and joins each level's configured `path`.
 */
export function routePattern(router: Router): string {
	let route: ActivatedRouteSnapshot | null = router.routerState.snapshot.root;
	const parts: string[] = [];
	while (route) {
		const configPath = route.routeConfig?.path;
		if (configPath) {
			parts.push(configPath);
		}
		route = route.firstChild;
	}
	return `/${parts.join('/')}`;
}
